import { render, staticRenderFns } from "./PrecintoMovimiento.vue?vue&type=template&id=0a2ed39a"
import script from "./PrecintoMovimiento.vue?vue&type=script&lang=js"
export * from "./PrecintoMovimiento.vue?vue&type=script&lang=js"
import style0 from "./PrecintoMovimiento.vue?vue&type=style&index=0&id=0a2ed39a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports